<template>
  <div>
<!--    <a-alert-->
<!--        message="您的 VIP 账号信息还剩20天，请联系专属客服顾问(点击右侧客服图标)续费"-->
<!--        type="warning"-->
<!--        show-icon-->
<!--        closable-->
<!--        class="mu-alert"-->
<!--    />-->
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>